import { useFormErrorFocus } from 'hooks';

export const FormErrorFocus = () => {
  useFormErrorFocus('center');
  return null;
};
